import { Component, OnInit, ChangeDetectorRef } from '@angular/core';
import { AccountService,InstoreService } from '@app/_services';
import { first } from 'rxjs/operators';
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { IDropdownSettings } from 'ng-multiselect-dropdown';
import { Sort} from '@angular/material/sort';
import { Router } from '@angular/router';

@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.css']
})
export class DashboardComponent implements OnInit {
    isLoading = false;
    allAds :any=[];
    newAds :any=[];
    liveAds : any=[];
    expiredAds :any;
    upComingAds:any;
    expiringAds:any;
    form: UntypedFormGroup;

    listTitle= "CURRENT ACTIVITY";

    dataLiveAds:number =0;
    dataNewAds:number =0;
    dataExpiredAds:number =0;
    dataExpiringAds:number =0;
    dataUpcomingAds:number =0;
    dataOverallAds:number =0;
    isCurrent:boolean = true;
    isChecked = false;
    instore_expiry30 :any=[];
    hoarding_expiry30:any=[];
    
    AssetsDataLists;
    CreativeDataLists;
    VendorDataLists;

    page = 1;
    pageSize = 10;
    pageHoardings = 1;
    pageSizeHoardings = 10;
    term: string;
    
    dropdownSettings:IDropdownSettings;
    instoreLists:any=[];
    liveCampaign:any=[];
    hoardingLists :any=[];

    f_instoreLists:any=[];
    f_hoardingLists :any=[];


    total_All_Activity:number;
    total_Instore:number;
    total_Hoardings:number;
    filterform: UntypedFormGroup;

    selectedAssetID = [];
    selectedCreativeIds =[];
    selectedVendorIds =[];
    is_Admin_User:boolean = true;
    is_Admin_can_Edit:boolean = true;
    user_role_id: number=0;
    user_region_id: number=0;
    user_showroom_id: number=0;

    ChartLabels = ['Upcoming Activity', 'New Activity', 'Current Activity',  'Expiring Activity','Expired Activity'];
    ChartData:any = [{ data: []}];
    ChartType = 'doughnut';
    Colors=[
      {
        backgroundColor: ['#3f51b5','#007500','#F5C00B','#E35F1E', '#B92930']
      }
    ];
    Options = {
      legend: {
        display: false
      },
      plugins: {
        labels: {
          fontColor: '#ffffff',
          fontSize: 14,
          render: function (args) {
            return args.value;
          }
        },
      }
    };

    constructor(private router: Router,
      private cdRef: ChangeDetectorRef,
      private accountService: AccountService,
      private formBuilder: UntypedFormBuilder, 
      private instoreService: InstoreService
  ) { }

  ngOnInit(): void {

    var userdata = localStorage.getItem('userInformation');
    var _data = JSON.parse(userdata);
    if(_data) {
      this.user_role_id = _data.role_id;
      this.user_region_id = _data.region_id;
      this.user_showroom_id = _data.showroom_id;

      if(this.user_role_id==1 || this.user_role_id == 2){
        this.is_Admin_User = true
      }else{
        this.is_Admin_User = false
      }

      if(this.is_Admin_User){
        if(_data.is_view == 1){
          this.is_Admin_can_Edit = false;
        }else{
         this.is_Admin_can_Edit = true;
        }
      }
    }


      this.getDashboardData();
      this.getLiveAds(0);
      
      this.filterform = this.formBuilder.group({
        asset_type_id: [''],
        creative_id: [''], 
        vendor_id:[''],
        search: ['']
      });

      this.form = this.formBuilder.group({
        include: [''],
      });

      this.dropdownSettings = {
        singleSelection: false,
        idField: 'id',
        textField: 'name',
        selectAllText: 'Select All',
        unSelectAllText: 'Unselect All',
        itemsShowLimit: 2,
    }
      
    this.reloadAssetsLists();
    this.reloadCreativeLists();
    this.reloadVendorLists() 
    }
  
    getDashboardData(){
      this.accountService.getDashboardData(this.user_showroom_id)
      .pipe(first())
        .subscribe(
        (response) => {
          this.isLoading = false;
        this.allAds = response.result.all_ads;
        this.newAds = response.result.new_ads;
        this.liveAds = response.result.live_ads;
        this.expiredAds = response.result.expiry_ads;
        this.upComingAds= response.result.upcoming_ads;
        this.expiringAds= response.result.expiring_ads;

        this.total_All_Activity =this.allAds.instore+this.allAds.hoarding;
        this.total_Instore = this.allAds.instore;
        this.total_Hoardings = this.allAds.hoarding;

        this. dataLiveAds = this.liveAds.instore+this.liveAds.hoarding;
        this. dataNewAds = this.newAds.instore+this.newAds.hoarding;
        this. dataExpiredAds = this.expiredAds.instore+this.expiredAds.hoarding;
        this. dataUpcomingAds = this.upComingAds.instore+this.upComingAds.hoarding;
        this. dataExpiringAds = this.expiringAds.instore+this.expiringAds.hoarding;


        this.dataOverallAds = this.dataUpcomingAds+this.dataNewAds+this.dataLiveAds+this.dataExpiredAds;
      
        this.ChartData = [this.dataUpcomingAds,this.dataNewAds,this.dataLiveAds,this.dataExpiringAds,this.dataExpiredAds];	 
        //  console.log( this.ChartData)
              
        },
      (error) => {     
        this.isLoading = false;                               
      }
      );
    }

    sortData(sort: Sort) {
      const data = this.f_instoreLists.slice();
      if (!sort.active || sort.direction === '') {
        this.f_instoreLists = data;
        return;
      }
      
      this.f_instoreLists = data.sort((a, b) => {
        let isAsc = sort.direction == 'asc';
        switch (sort.active) {
          case 'expiryDays': return this.accountService.compare(a.expiryDays, b.expiryDays, isAsc);
          case 'regionName': return this.accountService.compare(a.regionName, b.regionName, isAsc);
          case 'showroomName': return this.accountService.compare(a.showroomName, b.showroomName, isAsc);
          case 'floorName': return this.accountService.compare(a.floorName, b.floorName, isAsc);
          case 'locationName': return this.accountService.compare(a.locationName, b.locationName, isAsc);
          case 'assetTypeName': return this.accountService.compare(a.assetTypeName, b.assetTypeName, isAsc);
          case 'creativeName': return this.accountService.compare(a.creativeName, b.creativeName, isAsc);
          case 'vendorName': return this.accountService.compare(a.vendorName, b.vendorName, isAsc);
          default: return 0;
        }
      });
    }

    sortHoardingData(sort: Sort) {
      const data = this.f_hoardingLists.slice();
      if (!sort.active || sort.direction == '') {
        this.f_hoardingLists = data;
        return;
      }
      
      this.f_hoardingLists = data.sort((a, b) => {
        let isAsc = sort.direction == 'asc';
        switch (sort.active) {
          case 'expiryDays': return this.accountService.compare(a.expiryDays, b.expiryDays, isAsc);
          case 'regionName': return this.accountService.compare(a.regionName, b.regionName, isAsc);
          case 'showroomName': return this.accountService.compare(a.showroomName, b.showroomName, isAsc);
          case 'assetTypeName': return this.accountService.compare(a.assetTypeName, b.assetTypeName, isAsc);
          case 'creativeName': return this.accountService.compare(a.creativeName, b.creativeName, isAsc);
          case 'vendorName': return this.accountService.compare(a.vendorName, b.vendorName, isAsc);
          default: return 0;
        }
      });
    }
    clearFilters() {
    
      this.filterform.get("asset_type_id").setValue([]);
      this.filterform.get("creative_id").setValue([]);
      this.filterform.get("vendor_id").setValue([]);
      this.filterform.get("search").setValue('');
      
      this.selectedAssetID = [];
      this.selectedCreativeIds =[];
      this.selectedVendorIds =[];

      this.filterInstore();
      this.filterHoardings();


  }
  getUpcomingAds(){
    this.isCurrent= false;
    this.listTitle= "UPCOMING ACTIVITY";
    this.accountService.getUpcomingAds(this.user_showroom_id)
    .pipe(first())
      .subscribe(
      (response) => {
        this.isLoading = false;
       // console.log("--.result ----"+JSON.stringify(response.result))
        this.instoreLists = response.result.instore;
        this.liveCampaign = response.result.campaign;
        this.hoardingLists = response.result.hoarding;

        this.f_instoreLists = this.instoreLists;
        this.f_hoardingLists = this.hoardingLists;
        this.sortArray(this.f_instoreLists)
        this.sortArray(this.f_hoardingLists)
      },
    (error) => {     
      this.isLoading = false;                               
    }
    );
  }
  getNewAds(){
    this.isCurrent= false;
    this.listTitle= "NEW ACTIVITY";
    this.accountService.getNewAds(this.user_showroom_id)
    .pipe(first())
      .subscribe(
      (response) => {
        //console.log("getNewAds - - "+JSON.stringify(response.result))
        this.isLoading = false;
        this.instoreLists = response.result.instore;
        this.liveCampaign = response.result.campaign;
        this.hoardingLists = response.result.hoarding;

        this.f_instoreLists = this.instoreLists;
        this.f_hoardingLists = this.hoardingLists;
        this.sortArray(this.f_instoreLists)
        this.sortArray(this.f_hoardingLists)
      },
    (error) => {     
      this.isLoading = false;                               
    }
    );
  }
  getExpiryAds(){
    this.isCurrent= false;
    this.listTitle= "EXPIRED ACTIVITY";
    this.accountService.getExpiryAds(this.user_showroom_id)
    .pipe(first())
      .subscribe(
      (response) => {
        this.isLoading = false;
        this.instoreLists = response.result.instore;
        this.liveCampaign = response.result.campaign;
        this.hoardingLists = response.result.hoarding;

        this.f_instoreLists = this.instoreLists;
        this.f_hoardingLists = this.hoardingLists;
        this.sortArray(this.f_instoreLists)
        this.sortArray(this.f_hoardingLists)
      
      },
    (error) => {     
      this.isLoading = false;                               
    }
    );
  }
  // get sortByExpiryDays() {
  //   return this.f_instoreLists.sort((a: any, b: any) => {
  //     return <any>new Date(b.expiryDays) - <any>new Date(a.expiryDays);
  //   });
  // }

  sortArray(activityLists: { expiryDays: number; }[]) {
    activityLists.sort(this.compare);
  }
  compare( a, b ) {
    return a.expiryDays - b.expiryDays
  }


  callInstoreActivity(data){
    this.router.navigateByUrl('/', {skipLocationChange: true}).then(() => {
      this.router.navigate(['instorelist']);
    });
     this.instoreService.setInstoreData(data)
  }
  callHoardingActivity(data){
    this.router.navigateByUrl('/', {skipLocationChange: true}).then(() => {
      this.router.navigate(['hoardinglist']);
    });
     this.instoreService.setHoardingData(data)
  }
  getLiveAds(type:number){
    this.isCurrent= true;
    if(type==0){
      this.listTitle= "CURRENT ACTIVITY";
    }else{
      this.listTitle= "EXPIRING ACTIVITY";
    }
  
    this.accountService.getLiveAds(this.user_showroom_id)
    .pipe(first())
      .subscribe(
      (response) => {
        this.isLoading = false;
        this.instoreLists = response.result.instore;
        this.liveCampaign = response.result.campaign;
        this.hoardingLists = response.result.hoarding;

        if(type==0){
          this.f_instoreLists = this.instoreLists;
          this.f_hoardingLists = this.hoardingLists;
        }else{
          this.f_instoreLists = this.instoreLists.filter(obj => obj.expiryDays <= 30);
          this.f_hoardingLists = this.hoardingLists.filter(obj => obj.expiryDays <= 30);
        }
        this.sortArray(this.f_instoreLists)
        this.sortArray(this.f_hoardingLists)
        this.instore_expiry30 = this.f_instoreLists.filter(obj => obj.expiryDays <= 30);
        this.hoarding_expiry30 = this.f_hoardingLists.filter(obj => obj.expiryDays <= 30);
       
      },
    (error) => {     
      this.isLoading = false;                               
    }
    );
  }

  getColor(days:number): string {
    if(0 >= days) 
      return 'red';
    if(days>=1 && days <=10)
      return '#DA8C10';
  }
  
  public splitNumber(value: number):string {
    if(value!=null){
      if(value == 0){
        return 0+"";
      }

      return Math.round(value * 100) / 100+"'";
      // var str = value.toString();
      // var numarray = str.split('.');
      // var a = new Array();
      // a = numarray;

      // if(a[1] ==0 || a[1] == null|| a[1] == ''|| a[1] ==undefined){
      //   return a[0]+"'";
      // }else{
      //   a[1] = a[1].slice(0, 2);
      //   return a[0] +"' "+ a[1]+"\"";
      // }
    }
  }

  getHeight(height:number): number {
    let feet = Math.floor(height / 12);
    return feet;
    
  }


  reloadAssetsLists(){
  this.accountService.getAssetsLists()
    .pipe(first())
      .subscribe(
      (response) => {
        this.AssetsDataLists = response.result;
      },
    (error) => {     
    }
    );
  }
  reloadCreativeLists(){
    this.accountService.getCreativeLists()
    .pipe(first())
      .subscribe(
      (response) => {
        this.CreativeDataLists = response.result;
      },
    (error) => {     
    }
    );
  }


   reloadVendorLists(){
    this.accountService.getVendorLists()
    .pipe(first())
      .subscribe(
      (response) => {
        this.VendorDataLists = response.result;
      },
    (error) => {     
    }
    );
  }




  onItemSelect(item: any) {
    this.selectedAssetID.push(item.id);
     this.filterInstore();
     this.filterHoardings();
  }
  onSelectAll() {
    this.selectedAssetID = this.AssetsDataLists.map(x => x.id);
    this.selectedAssetID = this.selectedAssetID.filter(function(elem, index, self) {
      return index === self.indexOf(elem);
    })
    this.filterInstore();
    this.filterHoardings();
  }
  onDeSelectAll() {
    this.selectedAssetID = [];
    this.filterInstore();
    this.filterHoardings();
  }
  onItemDeSelect(item: any) {
      this.selectedAssetID.forEach((value,index)=>{
      if(value==item.id) this.selectedAssetID.splice(index,1);
    });
    this.filterInstore();
    this.filterHoardings();
  }

  
  onCreativeItemSelect(item: any) {
    
    this.selectedCreativeIds.push(item.id);
    this.filterInstore();
    this.filterHoardings();
  }
  onCreativeSelectAll() {
    this.selectedCreativeIds = this.CreativeDataLists.map(x => x.id);
    this.selectedCreativeIds = this.selectedCreativeIds.filter(function(elem, index, self) {
      return index === self.indexOf(elem);
    })
    this.filterInstore();
    this.filterHoardings();
  }
  onCreativeDeSelectAll() {
    this.selectedCreativeIds = [];
    this.filterInstore();
    this.filterHoardings();
  }
  onCreativeItemDeSelect(item: any) {
    this.selectedCreativeIds.forEach((value,index)=>{
      if(value==item.id) this.selectedCreativeIds.splice(index,1);
    });

    this.filterInstore();
    this.filterHoardings();
  }


  onVendorItemSelect(item: any) {
    
    this.selectedVendorIds.push(item.id);
    this.filterInstore();
    this.filterHoardings();
  }
  onVendorSelectAll() {
    // this.selectedVendorIds = this.InstoreExpiredLists.map(x => x.vendor_id);
    this.selectedVendorIds = this.VendorDataLists.map(x => x.id);
    this.selectedVendorIds = this.selectedVendorIds.filter(function(elem, index, self) {
      return index === self.indexOf(elem);
    })
    this.filterInstore();
    this.filterHoardings();
  }
  onVendorDeSelectAll() {
    this.selectedVendorIds = [];
    this.filterInstore();
    this.filterHoardings();
  }
  onVendorItemDeSelect(item: any) {
    this.selectedVendorIds.forEach((value,index)=>{
      if(value==item.id) this.selectedVendorIds.splice(index,1);
    });
    this.filterInstore();
    this.filterHoardings();
  }


  filterInstore(){

    if(this.selectedAssetID.length>0  &&  this.selectedCreativeIds.length==0 &&  this.selectedVendorIds.length==0){
        this.f_instoreLists = [
           ...this.instoreLists.filter(x => this.selectedAssetID.includes(x.asset_type_id))
      ];
    }else if(this.selectedAssetID.length==0 &&  this.selectedCreativeIds.length>0 &&  this.selectedVendorIds.length==0){
        this.f_instoreLists = [
            ...this.instoreLists.filter(x => this.selectedCreativeIds.includes(x.creative_id))
      ];
    }else if(this.selectedAssetID.length==0 &&  this.selectedCreativeIds.length==0 &&  this.selectedVendorIds.length>0){
        this.f_instoreLists = [
            ...this.instoreLists.filter(x => this.selectedVendorIds.includes(x.vendor_id))
      ];
    }


   else if(this.selectedAssetID.length>0  &&  this.selectedCreativeIds.length>0 &&  this.selectedVendorIds.length==0){
    this.f_instoreLists = [
      ...this.instoreLists.filter(x => this.selectedAssetID.includes(x.asset_type_id) && this.selectedCreativeIds.includes(x.creative_id))
    ];
    }else if(this.selectedAssetID.length>0 &&  this.selectedCreativeIds.length==0 &&  this.selectedVendorIds.length>0){
      this.f_instoreLists = [
        ...this.instoreLists.filter(x => this.selectedAssetID.includes(x.asset_type_id) && this.selectedVendorIds.includes(x.vendor_id))
      ];
    }else if(this.selectedAssetID.length==0 &&  this.selectedCreativeIds.length>0 &&  this.selectedVendorIds.length>0){
      this.f_instoreLists = [
        ...this.instoreLists.filter(x => this.selectedCreativeIds.includes(x.creative_id) && this.selectedVendorIds.includes(x.vendor_id))
      ];
    }



    else if(this.selectedAssetID.length==0 &&  this.selectedCreativeIds.length==0 &&  this.selectedVendorIds.length==0){
        this.f_instoreLists = [...this.instoreLists];
    }else{
        this.f_instoreLists = [
          ...this.instoreLists.filter(x => this.selectedAssetID.includes(x.asset_type_id) && this.selectedCreativeIds.includes(x.creative_id)&& this.selectedVendorIds.includes(x.vendor_id))
        ];
    }
  }

  filterHoardings(){

    if(this.selectedAssetID.length>0  &&  this.selectedCreativeIds.length==0 &&  this.selectedVendorIds.length==0){
        this.f_hoardingLists = [
           ...this.hoardingLists.filter(x => this.selectedAssetID.includes(x.asset_type_id))
      ];
    }else if(this.selectedAssetID.length==0 &&  this.selectedCreativeIds.length>0 &&  this.selectedVendorIds.length==0){
        this.f_hoardingLists = [
            ...this.hoardingLists.filter(x => this.selectedCreativeIds.includes(x.creative_id))
      ];
    }else if(this.selectedAssetID.length==0 &&  this.selectedCreativeIds.length==0 &&  this.selectedVendorIds.length>0){
        this.f_hoardingLists = [
            ...this.hoardingLists.filter(x => this.selectedVendorIds.includes(x.vendor_id))
      ];
    }


   else if(this.selectedAssetID.length>0  &&  this.selectedCreativeIds.length>0 &&  this.selectedVendorIds.length==0){
    this.f_hoardingLists = [
      ...this.hoardingLists.filter(x => this.selectedAssetID.includes(x.asset_type_id) && this.selectedCreativeIds.includes(x.creative_id))
    ];
    }else if(this.selectedAssetID.length>0 &&  this.selectedCreativeIds.length==0 &&  this.selectedVendorIds.length>0){
      this.f_hoardingLists = [
        ...this.hoardingLists.filter(x => this.selectedAssetID.includes(x.asset_type_id) && this.selectedVendorIds.includes(x.vendor_id))
      ];
    }else if(this.selectedAssetID.length==0 &&  this.selectedCreativeIds.length>0 &&  this.selectedVendorIds.length>0){
      this.f_hoardingLists = [
        ...this.hoardingLists.filter(x => this.selectedCreativeIds.includes(x.creative_id) && this.selectedVendorIds.includes(x.vendor_id))
      ];
    }



    else if(this.selectedAssetID.length==0 &&  this.selectedCreativeIds.length==0 &&  this.selectedVendorIds.length==0){
        this.f_hoardingLists = [...this.hoardingLists];
    }else{
        this.f_hoardingLists = [
          ...this.hoardingLists.filter(x => this.selectedAssetID.includes(x.asset_type_id) && this.selectedCreativeIds.includes(x.creative_id)&& this.selectedVendorIds.includes(x.vendor_id))
        ];
    }
  }

}






